<template>
  <div class="guest-meal-apply-container">
    <headTitle title="职工注册"></headTitle>
    <div class="page-title">注册申请</div>
    <div class="apply-form">
      <van-form
        ref="form"
        input-align="left"
        error-message-align="left"
        @submit="onSubmit"
      >
        <van-field
          ref="studentInput"
          v-model.trim="form.nameAll"
          :border="false"
          name="nameAll"
          :rules="[
            { required: true, message: '请选择' + category },
            {
              validator: validatorSchool,
              message: `不存在该${category},请重新选择`
            }
          ]"
          :label="category"
          :placeholder="'请选择' + category"
          autocomplete="off"
          right-icon="arrow-down"
          :disabled="isH5 === 1"
          @input="showStudentList"
          @click-right-icon="showAllStudentList"
        >
          <template #label>
            <span class="form-label">{{ category }}</span>
          </template>
        </van-field>
        <!-- 学生列表 -->
        <div v-if="isShowStudentList" ref="studentList" class="student-list">
          <div
            v-for="item in filteredStudentList"
            :key="item.id"
            class="student-list-item"
            @click="onChooseStudent(item)"
          >
            {{ item.zhName }}
          </div>
        </div>

        <van-field
          v-model="form.name"
          name="name"
          label="姓名"
          placeholder="请填写姓名"
          maxlength="20"
          class="department"
          :rules="[{ required: true, message: '请填写姓名' }]"
        >
          <template #label>
            <span class="form-label">姓名</span>
          </template>
        </van-field>

        <van-field
          v-model="form.phone"
          label="手机号"
          placeholder="请输入手机号"
          type="number"
          maxlength="11"
          :rules="[
            { required: true, message: '请输入手机号' },
            {
              validator: validatorPhone,
              message: '请输入正确手机号格式'
            }
          ]"
        >
          <template #label>
            <span class="form-label">手机号</span>
          </template>
        </van-field>
        <van-field
          v-model="form.identityCard"
          label="身份证"
          maxlength="18"
          placeholder="请输入身份证"
          :rules="[
            {
              required: true,
              message: '请输入身份证号'
            },
            {
              pattern: /(^\d{15}$)|(^\d{17}(\d|X|x)$)/,
              message: '请输入身份证号正确格式'
            }
          ]"
        >
          <template #label>
            <span class="form-label">身份证</span>
          </template>
        </van-field>
        <van-field
          v-model="form.genderName"
          readonly
          clickable
          name="genderName"
          label="性别"
          placeholder="请选择性别"
          right-icon="arrow-down"
          class="company"
          :rules="[{ required: true, message: '请选择性别' }]"
          @click="isShowGenderPicker = true"
        >
          <!-- 自定义文本 -->
          <template #label>
            <span class="form-label">性别</span>
          </template>
        </van-field>
        <van-field
          v-model="form.className"
          :disabled="!form.userId"
          readonly
          clickable
          name="className"
          label="部门"
          placeholder="请选择部门"
          right-icon="arrow-down"
          class="company"
          :rules="[{ required: true, message: '请选择部门' }]"
          @click="onShowPicker"
        >
          <!-- 自定义文本 -->
          <template #label>
            <span class="form-label">部门</span>
          </template>
        </van-field>

        <van-field
          v-model="form.jobName"
          readonly
          clickable
          name="jobName"
          label="岗位"
          placeholder="请选择岗位"
          right-icon="arrow-down"
          class="company"
          :rules="[{ required: true, message: '请选择岗位' }]"
          @click="isShowJobPicker = true"
        >
          <!-- 自定义文本 -->
          <template #label>
            <span class="form-label">岗位</span>
          </template>
        </van-field>

        <van-field
          v-model="form.smsCode"
          label="验证码"
          maxlength="6"
          placeholder="请输入短信验证码"
          :rules="[{ required: true, message: '请输入短信验证码' }]"
        >
          <!-- 自定义文本 -->
          <template #label>
            <span class="form-label">验证码</span>
          </template>
          <template #button>
            <van-button
              native-type="button"
              plain
              size="mini"
              class="get-code-btn"
              :disabled="!showTime"
              @click.stop="getCode"
            >
              {{ !showTime ? sendTime + '秒' : '获取验证码' }}
            </van-button>
          </template>
        </van-field>

        <!-- 所属公司 -->
        <van-popup v-model="showPicker" position="bottom">
          <van-cascader
            v-model="form.dptId"
            title="请选择用餐部门"
            :options="companyList"
            :field-names="fieldNames"
            active-color="#00B893"
            @close="showPicker = false"
            @change="onChangeNode"
            @finish="onFinishNode"
          />
        </van-popup>
        <van-popup v-model="isShowGenderPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="genderList"
            value-key="name"
            @confirm="onConfirmGender"
            @cancel="isShowGenderPicker = false"
          />
        </van-popup>

        <van-popup v-model="isShowJobPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="jobList"
            value-key="name"
            @confirm="onConfirmJob"
            @cancel="isShowJobPicker = false"
          />
        </van-popup>

        <div
          style="
            padding: 43px 16px 150px 16px;
            background-color: #fff !important;
            height: 0 !important;
          "
        >
          <van-button
            square
            block
            type="info"
            native-type="submit"
            style="border-radius: 4px; font-size: 18px"
            color="#FA5050"
          >
            提交
          </van-button>
        </div>
      </van-form>
    </div>
    <van-overlay :show="showLoading">
      <van-loading color="#1989fa" />
    </van-overlay>
  </div>
</template>

<script>
import headTitle from '@/components/headTitle/index.vue';
import { identifyingCode } from '@/api/api';
import { getPaginationList, getDptsAPI, submitUser } from '@/api/api';

import { Toast } from 'vant';
import { getCurrentOrg } from '@/api/change-phone/index.js';

export default {
  name: 'GuestMealApply',
  components: {
    headTitle
  },
  data() {
    return {
      sendTime: '',
      showTime: true,
      timer: null,
      isShowGenderPicker: false,
      showLoading: false,
      showAdminPicker: false,
      showToastDialog: false,
      companyList: [],
      form: {
        phone: '',
        organizationId: null,
        dptId: null,
        role: 0,
        channel: 'stu',
        name: ''
      },
      value: null,
      isDisabled: true,
      adminList: [],
      // 判断当前环境是二维码进入还是管理员从h5进入
      organizationId: null,
      // 开始最小时间默认今天
      // 是否换行展示
      isLineFeed: false,
      showPicker: false,
      showStartTimePicker: false,
      showEndTimePicker: false,
      mealPeriodList: [],
      fieldNames: {
        text: 'name',
        value: 'id',
        children: 'children'
      },
      isShowStudentList: false,
      isShowJobPicker: false,
      currentStudentList: [], // 所有学生列表
      filteredStudentList: [], // 根据输入内容过滤后的学生列表
      genderList: [
        {
          name: '男',
          id: 1
        },
        {
          name: '女',
          id: 2
        }
      ],
      jobList: [
        {
          name: '职工',
          id: 0
        },
        {
          name: '教师',
          id: 1
        },
        {
          name: '行政',
          id: 2
        },
        {
          name: '宿管',
          id: 3
        },
        {
          name: '保安',
          id: 4
        },
        {
          name: '保洁',
          id: 5
        }
      ],
      isH5: 0,
      category: '机构'
    };
  },

  watch: {
    // 监听人次
    'form.number'(val) {
      if (val !== 1) {
        this.form.name = '';
      }
    },
    'form.guestNum'(val) {
      if (val !== 1) {
        this.form.guestName = '';
      }
    }
    // 'form.nameAll'(val, oldVal) {
    //   if (oldVal) {
    //     if (oldVal.length > val.length) {
    //       this.form.organizationId = '';
    //     }
    //   }
    // }
  },
  async created() {
    // if (Number(this.$route.query.category) === 1805) {
    //   this.category = '学校';
    // }
    this.category = '食堂';
    if (this.$route.query.organizationId) {
      this.form.organizationId = this.$route.query.organizationId;
      this.isH5 = 1;
      const res = await getCurrentOrg(this.form.organizationId);
      this.$set(this.form, 'nameAll', res.data.zhName);
      const dptList = await getDptsAPI({
        type: 1,
        organizationId: this.form.organizationId
      });
      this.companyList = dptList.data.data.emp.filter((item) => item.id !== -1);
    } else {
      const res = await getPaginationList();
      this.currentStudentList = res.data.records;
    }
  },
  mounted() {},
  methods: {
    onConfirmJob(item) {
      this.form.job = item.name;
      this.form.jobName = item.name;
      this.isShowJobPicker = false;
    },

    onShowPicker() {
      if (this.form.organizationId) {
        this.showPicker = true;
      } else {
        Toast('请先选择学校');
      }
    },
    onConfirmGender(item, index) {
      this.form.gender = item.id;
      this.form.genderName = item.name;
      this.isShowGenderPicker = false;
    },
    validatorSchool(value) {
      if (!this.form.organizationId) {
        return false;
      } else return true;
    },

    async onChooseStudent(item) {
      // 选择学生后更新表单数据，并隐藏学生列表
      this.form.nameAll = item.zhName;
      this.form.organizationId = item.id;
      const res = await getDptsAPI({
        type: 1,
        organizationId: this.form.organizationId
      });
      this.companyList = res.data.data.emp.filter((item) => item.id !== -1);
      this.isShowStudentList = false;
    },
    showAllStudentList() {
      if (this.isH5 === 1) return;

      this.isShowStudentList = true;
      if (this.isShowStudentList) {
        this.filteredStudentList = this.currentStudentList;

        this.$nextTick(() => {
          // 获取输入框的位置
          const inputRect = this.$refs.studentInput.$el.getBoundingClientRect();
          // 设置学生列表的位置
          this.$refs.studentList.style.top = inputRect.bottom + 'px';
          // 学生列表的right为0，即与输入框右对齐
          this.$refs.studentList.style.right = 16 + 'px';
        });
      }
    },
    showStudentList(value) {
      // 根据输入内容过滤学生列表
      if (!value) {
        this.isShowStudentList = false;
        return;
      }

      this.filteredStudentList = this.currentStudentList.filter((item) =>
        item.zhName.includes(value)
      );
      this.isShowStudentList = true;
      this.$nextTick(() => {
        // 获取输入框的位置
        const inputRect = this.$refs.studentInput.$el.getBoundingClientRect();
        // 设置学生列表的位置
        this.$refs.studentList.style.top = inputRect.bottom + 'px';
        // 学生列表的right为0，即与输入框右对齐
        this.$refs.studentList.style.right = 16 + 'px';
      });
    },
    async getCode() {
      if (!this.form.phone) {
        Toast.fail('请输入手机号!');
        return;
      }
      if (!this.validatorPhone(this.form.phone)) {
        Toast.fail('请输入正确的手机号!');
        return;
      }
      const params = {
        phone: this.form.phone,
        appKey: 'ZHONGHEZHIHUI123!@#'
      };

      const response = await identifyingCode(params);
      if (response.code === 0) {
        Toast('获取验证码成功');
        const defaulTime = 60;
        if (!this.timer) {
          this.sendTime = defaulTime;
          this.showTime = false;
          this.timer = setInterval(() => {
            if (this.sendTime > 0 && this.sendTime <= defaulTime) {
              this.sendTime--;
            } else {
              this.showTime = true;
              clearInterval(this.timer); // 清除定时器
              this.timer = null;
            }
          }, 1000);
        }
      }
    },

    onChangeNode(value, selectedOptions, tabIndex) {
      this.form.dptId = value.value;
      this.form.className =
        value.selectedOptions[value.selectedOptions.length - 1].name;
    },
    onFinishNode(value, selectedOptions, tabIndex) {
      this.form.dptId = value.value;
      this.form.className =
        value.selectedOptions[value.selectedOptions.length - 1].name;
      this.showPicker = false;
    },

    async onSubmit() {
      // 校验表单
      try {
        if (this.form.identityCard && this.form.identityCard.length !== 18) {
          Toast('请输入正确的身份证号');
          return;
        }
        this.showLoading = true;
        const res = await submitUser({
          ...this.form,
          openId: sessionStorage.getItem('abcCustID')
        });
        if (res.code === 0) {
          this.$toast.success('申请成功');
          // 清空当前表单
          this.form = {
            phone: '',
            identityCard: '',
            organizationId: this.$route.query?.organizationId,
            dptId: null,
            role: 0,
            channel: 'stu',
            name: '',
            isH5: this.isH5
          };
          if (!this.$route.query?.organizationId) {
            this.$router.push({
              name: 'Binding',
              query: {
                custID: sessionStorage.getItem('abcCustID')
              }
            });
          } else {
            this.$router.push({
              name: 'SubmitResult'
            });
          }
        } else {
          this.$toast.fail(res.message);
          this.showLoading = false;
        }
      } catch (error) {
        console.log(error);
        this.showLoading = false;
      }
    },

    // 校验手机号
    validatorPhone(value) {
      const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
      if (!reg.test(value)) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.form-label {
  font-size: 16px;
  font-family: 'PingFangSC-Regular, sans-serif';
  color: #333333;
  font-weight: 400;
}

::v-deep .van-field__control::-webkit-input-placeholder {
  font-size: 16px;
  font-weight: 400;
  color: rgba(196, 196, 196, 1);
}
::v-deep .van-checkbox-group--horizontal {
  width: 150px;
  text-align: center;
  display: flex;
  align-content: flex-start;
  flex-flow: row wrap;
  justify-content: right;
  .van-checkbox--horizontal {
    flex: 0 0 43%;
    margin-right: 0 !important;
  }
  .van-icon-success {
    border-radius: 2px !important;
  }
}
/* 输入框填写文字样式 */
::v-deep .van-field__control {
  font-size: 16px !important;
  font-family: 'PingFangSC-Regular, sans-serif';
  color: #666666;
  font-weight: 400;
}
.department {
  ::v-deep .van-field__control {
    font-size: 16px !important;
    font-family: 'PingFangSC-Regular, sans-serif';
    color: #666666;
    font-weight: 400;
    flex-wrap: nowrap;
    display: flex;
  }
}

.company {
  ::v-deep .van-field__control::-webkit-input-placeholder {
    font-size: 15px;
    font-weight: 400;
    color: rgba(196, 196, 196, 1);
  }
}
.disabled {
  ::v-deep .van-field__control::-webkit-input-placeholder {
    font-size: 15px;
    font-weight: 400;
    color: #e5e5e5;
  }

  ::v-deep .van-field__right-icon {
    color: #e5e5e5;
  }
}
.content {
  width: 100%;
}
.guest-meal-apply-container {
  height: 100%;
  background-color: #fff;
  .page-title {
    color: #333333;
    font-size: 27px;
    font-weight: 500;
    padding: 94px 0 64px 0;
    text-align: center;
  }
  ::v-deep .van-field__label {
    color: #333333;
    font-size: 16px;
    font-weight: 400;
    width: 68px;
    margin-right: 0;
  }
  .apply-form {
    background: #ffffff;
    .get-code-btn {
      border: 0;
      color: #fa5050;
      font-size: 15px;
      font-weight: 400;
    }

    .manager-toast {
      width: 343px;
      ::v-deep .van-dialog {
        width: 343px;
        border-radius: 10px;
        box-sizing: border-box;
        .van-dialog__header {
          padding-top: 28px;
          margin-bottom: 24px;
        }
        .head {
          font-size: 18px;
          font-family: 'PingFangSC-Regular';
          color: #333333;
          font-weight: 500;
          line-height: 18px;
        }
        .body {
          font-size: 16px;
          font-family: 'PingFangSC-Regular, sans-serif';
          color: #666666;
          font-weight: 400;
          line-height: 1.5;
          margin-bottom: 24px;
          padding: 0 16px;
        }
        .van-dialog__footer {
          height: 50px;
          font-size: 18px;
          font-family: 'PingFangSC-Regular';
          color: #fa5050;
          font-weight: 500;
          line-height: 18px;
        }
      }
    }
  }
}
.form-label-originEndTime {
  font-size: 16px;
  font-family: 'PingFangSC-Regular, sans-serif';
  color: #333333;
  font-weight: 400;
  position: absolute;
  right: 100px;
}

.disabled {
  color: #e5e5e5;
}

::v-deep .van-picker__toolbar {
  height: 50px;
  background-color: #f1f1f1;
  .van-picker__cancel {
    font-size: 16px;
    font-weight: 500;
    color: #666666;
    font-family: 'PingFangSC-Regular, sans-serif';
  }
  .van-picker__confirm {
    font-size: 16px;
    font-weight: 500;
    color: #fa5050;
    font-family: 'PingFangSC-Regular, sans-serif';
  }
}
::v-deep .van-picker-column__item {
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  color: #333333;
  font-family: 'PingFangSC-Regular, sans-serif';
}
.comment-van {
  ::v-deep .van-field__control {
    font-size: 13px !important;
    font-family: 'PingFangSC-Regular, sans-serif';
    color: #333333;
    font-weight: 400;
    background-color: #f2f2f2;
    height: 39px !important;
    line-height: 19.5px;
  }
  ::v-deep .van-field__value {
    height: 82px;
    box-sizing: border-box;
    background-color: #f2f2f2;
    padding: 16px 8px 16px 8px;
    border-radius: 4px;
  }
  ::v-deep .van-field__word-limit {
    color: #999999;
    font-size: 14px;
    background-color: #f2f2f2;
    margin-top: 0;
  }
}
.student-list {
  position: fixed;
  border-radius: 10px;
  overflow-y: auto; /* 添加滚动条 */
  width: 240px;
  max-height: 220px;
  background-color: #fff;
  z-index: 9999; /* 确保学生列表显示在其他内容上方 */
  box-shadow: 0 5px 15px 0 #00000014;
}

.student-list-item {
  width: 100%;
  height: 44px;
  padding: 10px;
  box-sizing: border-box;
  cursor: pointer;
  color: #666666;
  font-size: 16px;
  box-sizing: border-box;
  padding: 14px 0 14px 16px;
  font-family: 'PingFangSC-Regular';
  font-weight: 400;
}

::v-deep .van-field__control:disabled {
  -webkit-text-fill-color: #666 !important;
}
::v-deep .van-field__control:disabled::placeholder {
  -webkit-text-fill-color: #c8c9cc !important;
}
</style>
